<template> 
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ operationsData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : operationsData.length }} of {{ operationsData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <vs-button  class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button>
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="operationsData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import moduleQuotationList from '@/store/quotation/moduleOperationList.js'

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'


export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions
  },
  data () {
    return {
     searchQuery: '',

      // AgGrid
      gridApi: null,
      gridOptions: {},
      suppressSizeToFit: true,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'Quotation REF',   
          valueGetter: function(params) {
            return '#'+params.data.quotation_ref
          },
          filter: true,
          width: 100,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'Quotation Date',   
          valueGetter: function(params) {
            return params.data.date_quotation
          },
          filter: true,
          width: 100,
        },
        {
          headerName: 'Final invoice Date',   
          valueGetter: function(params) {
            if (params.data.balance_date) return params.data.balance_date
            else return params.data.final_date
          },
          filter: true,
          width: 100,
        },
        {
          headerName: 'Transport Date',   
          valueGetter: function(params) {
            if (params.data.transportdate) return params.data.transportdate
          },
          filter: true,
          width: 100,
        },
        {
          headerName: 'Transpit Period (days)',   
          valueGetter: function(params) {
            if (params.data.transit_periods) return params.data.transit_periods
          },
          filter: true,
          width: 100,
        },
        {
          headerName: 'Delivery Expected Date',   
          valueGetter: function(params) {
            return params.data.date_desired
          },
          filter: true,
          width: 100,
        },
        {
          headerName: 'Quotation status',   
          valueGetter: function(params) {
            if (params.data.quotation_status==2) return "Approved"
            else if (params.data.quotation_status==1) return "Pending"
          },
          filter: true,
          width: 100,
        },
        {
          headerName: 'Quotation value (EUR)',   
          valueGetter: function(params) {
            return params.data.quotation_amount
          },
          filter: true,
          width: 100,
        },
        {
          headerName: 'Quotation volume (EUR)',   
          valueGetter: function(params) {
            return params.data.quotation_volume
          },
          filter: true,
          width: 100,
        },
        {
          headerName: 'Advance Invoice',   
          valueGetter: function(params) {
            return params.data.advance_no
          },
          filter: true,
          width: 100,
        },
        {
          headerName: 'Is advance invoice paid?',   
          valueGetter: function(params) {
            if (params.data.isadvancepaid==2) return "TRUE"
            else if (params.data.isadvancepaid==1) return "FALSE"
          },
          filter: true,
          width: 100,
        },
        {
          headerName: 'Advance Invoice Value',   
          valueGetter: function(params) {
            return params.data.advanceamount
          },
          filter: true,
          width: 100,
        },
        {
          headerName: 'Advance Invoice Volume',   
          valueGetter: function(params) {
            return params.data.advancevolume
          },
          filter: true,
          width: 100,
        },
        
        
        {
          headerName: 'Balance Invoice',   
          valueGetter: function(params) {
            return params.data.balance_no
          },
          filter: true,
          width: 100,
        },
        {
          headerName: 'Is Balance invoice paid?',   
          valueGetter: function(params) {
            if (params.data.isbalancepaid==2) return "TRUE"
            else if (params.data.isbalancepaid==1) return "FALSE"
          },
          filter: true,
          width: 100,
        },
        {
          headerName: 'Balance Invoice Value',   
          valueGetter: function(params) {
            return params.data.balanceamount
          },
          filter: true,
          width: 100,
        },
        {
          headerName: 'Balance Invoice Volume',   
          valueGetter: function(params) {
            return params.data.balancevolume
          },
          filter: true,
          width: 100,
        },
        
        
        {
          headerName: 'Final Invoice',   
          valueGetter: function(params) {
            return params.data.final_no
          },
          filter: true,
          width: 100,
        },
        {
          headerName: 'Is Final invoice paid?',   
          valueGetter: function(params) {
            if (params.data.isfinalpaid==2) return "TRUE"
            else if (params.data.isfinalpaid==1) return "FALSE"
          },
          filter: true,
          width: 100,
        },
        {
          headerName: 'Final Invoice Value',   
          valueGetter: function(params) {
            return params.data.finalamount
          },
          filter: true,
          width: 100,
        },
        {
          headerName: 'Final Invoice Volume',   
          valueGetter: function(params) {
            return params.data.finalvolume
          },
          filter: true,
          width: 100,
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions
      }
    }
  },
  computed: {
    operationsData () {
      return this.$store.state.quotationList.operations
    },
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 100
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  }, 
  created () {
    this.$vs.loading()
    if (!moduleQuotationList.isRegistered) {
      this.$store.registerModule('quotationList', moduleQuotationList)
      moduleQuotationList.isRegistered = true
    }
    this.$store.dispatch('quotationList/fetchQuotationsVerifData')
    .then(response => {
      this.$vs.loading.close()
    })
    .catch(err => { console.error(err) })
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
